import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activityBookingsRoutes: MenuInterface[] = [
    {
        code: 'BookingsList',
        route: [
            {
                content: '$type/bookings/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'BookingsAvailabilities',
        route: [
            {
                content: '$type/bookings/availabilities',
                focus: 'empty'
            }, 'content'
        ]
    },
];
